module.exports = __webpack_public_path__ + "img/cluster_WASH_100px_bluebox.1f97dbc9.png";